var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRcs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50.588,
  height: 36.332,
  viewBox: "0 0 50.588 36.332"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Union_53",
  "data-name": "Union 53",
  d: "M15.564,36.333a6.688,6.688,0,0,1-6.681-6.681v-17.6L.656,3.823A2.239,2.239,0,0,1,2.239,0H43.907a6.689,6.689,0,0,1,6.682,6.682V29.652a6.689,6.689,0,0,1-6.682,6.681ZM12.706,9.539a2.244,2.244,0,0,1,.656,1.584V29.652a2.2,2.2,0,0,0,2.2,2.2H43.907a2.205,2.205,0,0,0,2.2-2.2V6.682a2.205,2.205,0,0,0-2.2-2.2H7.646Zm8.448,17.626a2,2,0,0,1,0-4h9.306a2,2,0,0,1,0,4Zm0-7a2.005,2.005,0,0,1,0-4H38.836a2.005,2.005,0,0,1,0,4Zm0-7a1.934,1.934,0,0,1-1.861-2,1.935,1.935,0,0,1,1.861-2H38.836a1.935,1.935,0,0,1,1.861,2,1.934,1.934,0,0,1-1.861,2Z",
  fill: "currentColor"
})));
export { SvgRcs as ReactComponent };
export default __webpack_public_path__ + "static/media/rcs.aea9bf4acc3fd71f8a8531bab02db16c.svg";